import BaseModel from '@/app-core/lib/data/model/BaseModel'
import formDataCommon from '@/app-core/mixins/form/formDataCommon'

export default {
  name     : 'FormData',
  dataModel: BaseModel,
  data() {
    return {}
  },
  mixins: [formDataCommon]
}
